// import i18n from '../../i18n';
// import PropTypes from 'prop-types';
import classNames from 'classnames';
import React from 'react';
import styles from './Stepper.module.scss';

const Stepper = ({ steps }) => {
    return (
        <div className={styles['Stepper']}>
            <div className={styles['Stepper__Wrap']}>
                <div className={styles['Stepper__Steps']}>
                    {steps &&
                        steps.map((step, i) => (
                            <Step
                                {...step}
                                key={i}
                                isFirst={i === 0}
                                isLast={i === steps.length - 1}
                            />
                        ))}
                </div>
            </div>
        </div>
    );
};

const Step = ({ title, html, isLast, isActive, isFirst, hasActiveLine }) => {
    const numberClasses = classNames(styles['Step__Number'], {
        [styles['Step__Number--Last']]: isLast,
        [styles['Step__Number--First']]: isFirst,
        [styles['Step__Number--ActiveLine']]: hasActiveLine || isActive,
        [styles['Step__Number--Active']]: isActive,
    });

    const numberWrapClasses = classNames(styles['Step__NumberWrap'], {
        [styles['Step__NumberWrap--Last']]: isLast,
        [styles['Step__NumberWrap--ActiveSmall']]: hasActiveLine,
        [styles['Step__NumberWrap--Active']]: isActive,
    });

    return (
        <div className={styles['Step']}>
            <div className={numberClasses}>
                <span className={numberWrapClasses} />
            </div>
            <div className={styles['Step__Wrap']}>
                <h3 className={styles['Step__Title']}>
                    {isActive} {title}
                </h3>
                <div
                    className={styles['Step__Html']}
                    dangerouslySetInnerHTML={{ __html: html.html }}
                />
            </div>
        </div>
    );
};

Stepper.propTypes = {};

Stepper.defaultProps = {};

export default Stepper;
